import CustomerAddScreen from "@assets/images/screens/CUSTOMER_ADD.png";
import CustomerProfileScreen from "@assets/images/screens/CUSTOMER_PROFILE.png";
import CustomerSearchScreen from "@assets/images/screens/CUSTOMER_SEARCH.png";
import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const CUSTOMER_DETAILS_ACTION_ROUTES: IRoutesDefined = {
  EDIT_PET: {
    id: "EDIT_PET",
    title: "edit_pet",
    path: "edit-pet",
    url: "/app/customer/profile/customer-details/edit-pet",
    description: "Editing of pet on the customer details page",
    icon: "AiFillSnippets",
    RBACDisplayName: "EDIT_PET",
    RBACDescription: "Edit customer pet details.",
    children: {},
  },
  EDIT_CUSTOMER: {
    id: "EDIT_CUSTOMER",
    title: "edit-customer",
    path: "edit-customer",
    RBACDisplayName: "EDIT_CUSTOMER",
    RBACDescription: "Edit pet parent details.",
    url: "/app/customer/profile/customer-details/edit-customer",
    description: "Editing of customer on the customer details page",
    icon: "AiFillSnippets",
    children: {},
  },

  ADD_PET: {
    id: "ADD_PET",
    title: "add-pet",
    path: "add-pet",
    RBACDisplayName: "ADD_PET",
    RBACDescription: "Add new pet under customer.",
    url: "/app/customer/profile/customer-details/add-pet",
    description: "Add pet for the current customer",
    icon: "AiFillSnippets",
    children: {},
  },
  ADD_USER_PERSONA_CTA: {
    id: "ADD_USER_PERSONA_CTA",
    title: "add-pet",
    path: "add-pet",
    RBACDisplayName: "ADD_USER_PERSONA_BUTTON_CTA",
    RBACDescription: "Add new pet under customer.",
    url: "/app/customer/profile/customer-details/add-pet/cta-action",
    description: "Add pet for the current customer",
    icon: "AiFillSnippets",
    children: {},
  },
  MANUAL_CONTROL_PANEL_BUTTON: {
    id: "MANUAL_CONTROL_PANEL_BUTTON",
    title: "manual-crt-control-panel",
    path: "manual-crt-control-panel",
    RBACDisplayName: "MANUAL_CONTROL_PANEL_BUTTON",
    RBACDescription: "Open the manual CRT control panel from the customer details page.",
    url: "/app/customer/profile/customer-details/manual-crt-control-panel",
    description: "Open manual CRT control panel for the current customer",
    icon: "AiFillSnippets",
    children: {},
  },
};

export const CUSTOMER_DETAILS_TABS: IRoutesDefined = {
  OTHER_INFORMATION_TAB: {
    id: "OTHER_INFORMATION_TAB",
    title: "other_information",
    path: "other-information",
    RBACDescription: "Other Information Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/other-information",
    icon: "BsDashCircleDotted",
    children: {},
  },
  VACCINATION_TAB: {
    id: "VACCINATION_TAB",
    title: "vaccination",
    path: "vaccination",
    url: "/app/customer/profile/customer-details/vaccination",
    RBACDescription: "Vaccination Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    // isVirtual: true,
    children: {},
  },
  VACCINATION_HISTORY_MANUAL_ACTION: {
    id: "VACCINATION_HISTORY_MANUAL_ACTION",
    title: "VACCINATION_HISTORY_MANUAL_ACTION Button",
    path: "mc",
    url: "/app/customer/profile/customer-details/vaccination/mc",
    RBACDescription: "Vaccination Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    // isVirtual: true,
    children: {},
  },

  USER_MOBILE_EDIT_ACTION: {
    id: "USER_MOBILE_EDIT_ACTION",
    title: "USER_MOBILE_EDIT_ACTION Button",
    path: "ml",
    url: "/app/customer/profile/customer-details/vaccination/ml",
    RBACDescription: "user mobile edit.",
    icon: "BsDashCircleDotted",
    // isVirtual: true,
    children: {},
  },
  USER_MOBILE_DISABLE_ACTION: {
    id: "USER_MOBILE_DISABLE_ACTION",
    title: "USER_MOBILE_DISABLE_ACTION Button",
    path: "md",
    url: "/app/customer/profile/customer-details/vaccination/md",
    RBACDescription: "If unchecked, mobile number field is shown but disabled for this role.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  VACCINATION_HISTORY_OCR_ACTION: {
    id: "VACCINATION_HISTORY_OCR_ACTION",
    title: "VACCINATION_HISTORY_OCR_ACTION Button",
    path: "ocr",
    url: "/app/customer/profile/customer-details/vaccination/ocr",
    RBACDescription: "Vaccination Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    // isVirtual: true,
    children: {},
  },
  MEDICINE_HISTORY: {
    id: "MEDICINE_HISTORY",
    title: "MEDICINE HISTORY",
    path: "medicine-history",
    url: "/app/customer/profile/customer-details/medicine-history",
    RBACDescription: "medicine-history Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  REMINDERS_TAB: {
    id: "REMINDERS_TAB",
    title: "reminders",
    path: "reminder",
    url: "/app/customer/profile/customer-details/reminder",
    RBACDescription: "Reminder Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  REMINDERS_CREATION: {
    id: "REMINDERS_CREATION",
    title: "reminders",
    path: "reminder-creation",
    url: "/app/customer/profile/customer-details/reminder-creation",
    RBACDescription: "Reminder Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  ADD_REMINDER_ACTION_BUTTON: {
    id: "ADD_REMINDER_ACTION_BUTTON",
    title: "add reminder",
    path: "action-cta-add-reminder",
    RBACDescription: "Add Reminder Action Button in customer profile.",
    RBACDisplayName: "ADD_REMINDER",
    url: "/app/customer/profile/customer-details/reminder/action-cta-add-reminder",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  APPOINTMENTS_TAB: {
    id: "APPOINTMENTS_TAB",
    title: "appointments",
    path: "appointments",
    RBACDescription: "Appointments Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/appointments",
    icon: "BsDashCircleDotted",
    children: {},
  },
  APPOINTMENTS_ACTION_BUTTON: {
    id: "APPOINTMENTS_ACTION_BUTTON",
    title: "appointments action",
    path: "action-cta",
    RBACDescription: "Appointments Tab Access in customer profile.",
    RBACDisplayName: "APPOINTMENTS_ACTION_BUTTON",
    url: "/app/customer/profile/customer-details/appointments/action-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  EMR_ACTION_BUTTON: {
    id: "EMR_ACTION_BUTTON",
    title: "Emr action",
    path: "cta",
    RBACDescription: "EMR action button",
    RBACDisplayName: "EMR_ACTION_BUTTON",
    url: "/app/customer/profile/emr-view/cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  VOICE_TO_EMR_ACTION_BUTTON_VOICE: {
    id: "VOICE_TO_EMR_ACTION_BUTTON_VOICE",
    title: "Voice to emr action voice",
    path: "cta",
    RBACDescription: "EMR action button",
    RBACDisplayName: "VOICE_TO_EMR_ACTION_BUTTON_VOICE",
    url: "/app/customer/profile/emr-view/cta-voice",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CLINIC_WISE_CUSTOMER_SEARCH: {
    id: "CLINIC_WISE_SEARCH",
    title: "clinic wise user search",
    path: "cta",
    RBACDescription: "EMR action button",
    RBACDisplayName: "CLINIC_WISE_CUSTOMER_SEARCH",
    url: "/app/customer/profile/search/cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  EMR_DOWNLOAD_BUTTON: {
    id: "EMR_DOWNLOAD_BUTTON",
    title: "Emr action",
    path: "cta",
    RBACDescription: "EMR Download button",
    RBACDisplayName: "EMR_DOWNLOAD_BUTTON",
    url: "/app/customer/profile/emr-view/ctad",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  EDIT_EMR_BUTTON: {
    id: "EDIT_EMR_BUTTON",
    title: "Emr action",
    path: "cta",
    RBACDescription: "EMR Edit button",
    RBACDisplayName: "EDIT_EMR_BUTTON",
    url: "/app/customer/profile/emr-view/ctae",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  DELETE_EMR_BUTTON: {
    id: "DELETE_EMR_BUTTON",
    title: "Emr action",
    path: "cta",
    RBACDescription: "EMR Delete button",
    RBACDisplayName: "DELETE_EMR_BUTTON",
    url: "/app/customer/profile/emr-view/cta-del",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  EMR_TAB: {
    id: "EMR_TAB",
    title: "EMR",
    path: "EMR",
    url: "/app/customer/profile/customer-details/EMR",
    RBACDescription: "EMR Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  LAB_TEST_TAB: {
    id: "LAB_TEST_TAB",
    title: "lab_test",
    path: "lab-test",
    url: "/app/customer/profile/customer-details/lab-test",
    RBACDescription: "LAB Test Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  LAB_INTERPRETATION_TAB: {
    id: "LAB_INTERPRETATION_TAB",
    title: "lab_interpretation",
    path: "lab-interpretation",
    url: "/app/customer/profile/customer-details/lab-interpretation",
    RBACDescription: "Lab Interpretation Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    children: {},
  },
  CERTIFICATES_TAB: {
    id: "CERTIFICATES_TAB",
    title: "certificates",
    path: "certificates",
    RBACDescription: "Certificate Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/certificates",
    icon: "BsDashCircleDotted",
    children: {},
    isVirtual: false,
  },
  UPLOAD_CERTIFICATES: {
    id: "UPLOAD_CERTIFICATES",
    title: "upload-certificates",
    path: "upload-certificates",
    RBACDescription: "Certificate Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/upload-certificates",
    icon: "BsDashCircleDotted",
    children: {},
  },
  ACTIVITY_TAB: {
    id: "ACTIVITY_TAB",
    title: "activity",
    path: "activity",
    RBACDescription: "Acitvity Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/activity",
    icon: "BsDashCircleDotted",
    children: {},
  },
  ACCOUNT_TAB: {
    id: "ACCOUNT_TAB",
    title: "account",
    path: "account",
    RBACDescription: "Account Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/account",
    icon: "BsDashCircleDotted",
    children: {},
  },
  INVOICE_TAB: {
    id: "INVOICE_TAB",
    title: "invoice",
    path: "invoice",
    RBACDescription: "Invoice Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/invoice",
    icon: "BsDashCircleDotted",
    children: {},
  },
  TICKECT_TAB: {
    id: "TICKECT_TAB",
    title: "ticket",
    path: "ticket",
    RBACDescription: "Ticket Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/ticket",
    icon: "BsDashCircleDotted",
    children: {},
  },
  MEMBERSHIP_DETAILS_TAB: {
    id: "MEMBERSHIP_DETAILS_TAB",
    title: "membership_details",
    children: {},
    path: "membership-details",
    icon: "BsDashCircleDotted",
    RBACDescription: "Membership Details Tab Access in customer profile.",
    url: "/app/customer/profile/customer-details/membership-details",
  },
  FORM_TAB: {
    id: "FORM_TAB",
    title: "multiple_form_for_clinic",
    children: {},
    path: "form-tab",
    RBACDescription: "Form Tab Access in customer profile.",
    icon: "BsDashCircleDotted",
    url: "/app/customer/profile/customer-details/form-tab",
  },
  ENTER_DATA_ACTION_CTA: {
    id: "ENTER_DATA_ACTION_CTA",
    title: "enter data list",
    RBACDescription: "Access to enter data list",
    RBACDisplayName: "VACCINATION_3aENTER_DATA_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "cta-action-enter-data",
    url: "/app/customer/profile/customer-details/vaccination/cta-action-enter-data",
    isVirtual: true,
    children: {},
  },
  EDIT_DOCUMENT_ACTION_CTA: {
    id: "EDIT_DOCUMENT_ACTION_CTA",
    title: "edit document list",
    RBACDescription: "Access to edit document list",
    RBACDisplayName: "CERTIFICATES_EDIT_DOCUMENT_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "action-cta-edit-document",
    url: "/app/customer/profile/customer-details/certificates/action-cta-edit-document",
    isVirtual: true,
    children: {},
  },
  DELETE_DOCUMENT_ACTION_CTA: {
    id: "DELETE_DOCUMENT_ACTION_CTA",
    title: "delete document list",
    RBACDescription: "Access to delete document list",
    RBACDisplayName: "CERTIFICATES_DELETE_DOCUMENT_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "action-cta-delete-document",
    url: "/app/customer/profile/customer-details/certificates/action-cta-delete-document",
    isVirtual: true,
    children: {},
  },
  SERVICE_CALL: {
    id: "SERVICE_CALL",
    title: "service call action",
    RBACDescription: "Access to Service Call action in customer profile communication modal.",
    RBACDisplayName: "SERVICE_CALL",
    icon: "BsCardChecklist",
    path: "service-call-action-cta",
    url: "/app/customer/profile/customer-details/service-call-action-cta",
    isVirtual: true,
    children: {},
  },
};

export const CUSTOMER_PROFILE_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  SEARCH_CUSTOMER: {
    id: "SEARCH_CUSTOMER",
    title: "search_customer",
    icon: "MdOutlinePersonSearch",
    url: "/app/customer/profile/search",
    RBACDisplayName: "SEARCH_CUSTOMER",
    screen: CustomerSearchScreen,
    RBACDescription: "Access to search customer action and apge.",
    path: "search",
    children: {},
  },
  CUSTOMER_SUPPORT: {
    id: "CUSTOMER_SUPPORT",
    title: "customer_support",
    icon: "HiOutlineUserCircle",
    path: "vms-support",
    url: "/app/customer/profile/vms-support",
    description: "Vms support",
    children: {},
  },
  USER_LEVEL_COUPON: {
    id: "USER_LEVEL_COUPON",
    title: "user_level_coupon",
    icon: "MdOutlineLocalOffer",
    path: "user-level-coupon",
    url: "/app/customer/profile/user-level-coupon",
    RBACDisplayName: "USER_LEVEL_COUPON",
    RBACDescription: "Access to create user level coupon copies.",
    children: {},
  },
  ADD_CUSTOMER: {
    id: "ADD_CUSTOMER",
    title: "add_customer",
    icon: "AiOutlineUserAdd",
    url: "/app/customer/profile/add",
    screen: CustomerAddScreen,
    RBACDisplayName: "ADD_CUSTOMER",
    RBACDescription: "Access to add customer action and apge.",
    path: "add",
    children: {},
  },
  DETAILS_CUSTOMER: {
    id: "DETAILS_CUSTOMER",
    title: "customer_details",
    icon: "BsPersonVcard",
    screen: CustomerProfileScreen,
    url: "/app/customer/profile/customer-details",
    path: "customer-details",
    RBACDisplayName: "CUSTOMER_DETAILS_PAGE",
    RBACDescription: "Access to customer details page",
    children: {
      ...CUSTOMER_DETAILS_TABS,
      ...CUSTOMER_DETAILS_ACTION_ROUTES,
    },
  },
  CUSTOMER_EMR: {
    id: "CUSTOMER_EMR",
    title: "customer_emr",
    icon: "",
    path: "customer-create-emr",
    RBACDisplayName: "CUSTOMER_EMR_CREATION_PAGE",
    RBACDescription: "Access to customer emr creation page and action.",
    url: "/app/customer/profile/customer-create-emr",
    children: {},
  },
  EMR_CREATION: {
    id: "EMR_CREATION",
    title: "EMR_CREATION",
    icon: "",
    path: "create-emr",
    RBACDisplayName: "EMR_CREATION PAGE",
    RBACDescription: "Access to customer emr creation page and action.",
    url: "/app/customer/profile/create-emr",
    children: {},
  },
  EMR_CREATION_BILABLE: {
    id: "EMR_CREATION_BILABLE",
    title: "EMR Bilable Toggle",
    RBACDescription: "Access to Emr bilable.",
    RBACDisplayName: "EMR Bilable Toggle",
    icon: "BsCardChecklist",
    path: "create-emr-bilable",
    url: "/app/customer/profile/create-emr-bilable",
    isVirtual: true,
    children: {},
  },
  BILLING_MIRROR_VIEW: {
    id: "BILLING_MIRROR_VIEW",
    title: "Screen mirror view",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "Cart mirror view",
    icon: "BsCardChecklist",
    path: "mirror-view",
    url: "/app/customer/profile/mirror-view",
    isVirtual: false,
    children: {},
  },
  EMR_PDF_VIEW: {
    id: "EMR_PDF_VIEW",
    path: "emr-view",
    title: "customer_emr_pdf_view",
    url: "/app/customer/profile/emr-view",
    RBACDisplayName: "CUSTOMER_EMR_PDF_VIEW",
    RBACDescription: "Access to view of customer emr. This blocks quick view and pdf download",
    icon: "",
    description: "View customer emr PDF view",
    children: {},
  },
  STOCK_INCOMPLETE_FORM: {
    id: "STOCK_INCOMPLETE_FORM",
    title: "STOCK_INCOMPLETE_FORM",
    path: "stock-incomplete-form",
    url: "/app/inventory/stock-incomplete-form",
    description: "stock incomplete form",
    children: {},
  },
  SMART_QC_DEEPLINK_CTA: {
    id: "SMART_QC_DEEPLINK_CTA",
    title: "SMART_QC_DEEPLINK_CTA",
    RBACDescription: "clinic and city , warehouse , equipment setup ",
    RBACDisplayName: "SMART_QC_DEEPLINK_CTA",
    icon: "BsCardChecklist",
    path: "smart-link",
    url: "/app/customer/profile/smart-link",
    isVirtual: true,
    children: {},
  },
  EMI_CALCULATOR_CTA: {
    id: "EMI_CALCULATOR_CTA",
    title: "EMI_CALCULATOR_CTA",
    RBACDescription: "EMI calculator action button on the customer profile.",
    RBACDisplayName: "EMI_CALCULATOR_CTA",
    icon: "BsCardChecklist",
    path: "emi-calculator",
    url: "/app/customer/profile/emi-calculator",
    isVirtual: true,
    children: {},
  },

  // ── RBAC virtual features (customer-scoped) ──────────────────────
  EMR_TEMPLATE_DELETE_LOCKED_ITEM: {
    id: "EMR_TEMPLATE_DELETE_LOCKED_ITEM",
    title: "emr template delete locked item",
    path: "cta",
    RBACDisplayName: "EMR_TEMPLATE_DELETE_LOCKED_ITEM",
    RBACDescription: "Delete locked child items in EMR templates (food/diet, medicines, treatments, deworming, lab tests).",
    url: "/app/emr-template/delete-locked-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  EMR_MENU_ADMIN_ACTIONS: {
    id: "EMR_MENU_ADMIN_ACTIONS",
    title: "emr menu admin actions",
    path: "cta",
    RBACDisplayName: "EMR_MENU_ADMIN_ACTIONS",
    RBACDescription: "Bypass EMR menu restrictions — delete/edit any EMR regardless of status/window/owner.",
    url: "/app/customer/emr-menu/admin-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CUSTOMER_ADDRESS_BLUECITY_VARIANT: {
    id: "CUSTOMER_ADDRESS_BLUECITY_VARIANT",
    title: "customer address bluecity variant",
    path: "cta",
    RBACDisplayName: "CUSTOMER_ADDRESS_BLUECITY_VARIANT",
    RBACDescription: "Show Bluecity-specific variant of customer address form (Add Customer flow).",
    url: "/app/customer/add/address-bluecity-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CERTIFICATE_DOGGYWORLD_LETTERHEAD: {
    id: "CERTIFICATE_DOGGYWORLD_LETTERHEAD",
    title: "certificate doggyworld letterhead",
    path: "cta",
    RBACDisplayName: "CERTIFICATE_DOGGYWORLD_LETTERHEAD",
    RBACDescription: "Show Doggy World letterhead on customer certificates.",
    url: "/app/customer/certificate/doggyworld-letterhead-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  SOCKET_EXOTEL_ROUTING: {
    id: "SOCKET_EXOTEL_ROUTING",
    title: "socket exotel routing",
    path: "cta",
    RBACDisplayName: "SOCKET_EXOTEL_ROUTING",
    RBACDescription: "Route this user's websocket to the Exotel socket URL (sales ops call flow).",
    url: "/app/socket/exotel-routing-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  SOCKET_INCOMING_CALL_HANDLER: {
    id: "SOCKET_INCOMING_CALL_HANDLER",
    title: "socket incoming call handler",
    path: "cta",
    RBACDisplayName: "SOCKET_INCOMING_CALL_HANDLER",
    RBACDescription: "Enable INCOMING_CALL websocket event handling for this user.",
    url: "/app/socket/incoming-call-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  UI_CLINIC_NUDGE_NOTIFICATION: {
    id: "UI_CLINIC_NUDGE_NOTIFICATION",
    title: "ui clinic nudge notification",
    path: "cta",
    RBACDisplayName: "UI_CLINIC_NUDGE_NOTIFICATION",
    RBACDescription: "Show the clinic-side toast/nudge notification in the app shell.",
    url: "/app/ui/clinic-nudge-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  VOICE_TO_EMR_BUTTON: {
    id: "VOICE_TO_EMR_BUTTON",
    title: "voice to emr button",
    path: "cta",
    RBACDisplayName: "VOICE_TO_EMR_BUTTON",
    RBACDescription:
      "Show the Voice to EMR entry point — the start button on the customer profile and the recorder panel on the EMR editing page. Intended for doctors and super admins.",
    url: "/app/emr/voice-to-emr-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },

};

